import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const DonationsView = angular
  .module('acme.view.application.donations', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.donations.amount',
    'acme.view.application.donations.config',
    'acme.view.application.donations.controllers',
    'acme.common.directive.dataGrid',
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const donations = {
      name: 'application.donations',
      url: '/donations',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'DonationsController',
          templateUrl: 'views/application/views/donations/donations.tpl.html',
        },
      },
      data: {
        pageTitle: ' ',
      },
    };

    $stateProvider.state(donations);
  }).name;
